// @flow

import { connect } from 'react-redux';

import {
  addCurrentSearchParamsToHistory, updateSearchParam, updateSearchMeta, resetSearchPrams,
} from '../../../services/search';
import ShareholderCard from './shareholdercard';

export type Props = {
  role: string,
  caeNumber: string,
  artistName: string,
  performingShare: string,
  mechanicalShare: string,
  children: Element,
  addCurrentSearchParamsToHistory: () => void,
  updateSearchMeta: () => void,
  resetSearchPrams: () => void,
};

const mapState = ({ search, authentication }) => ({
  search: search.search,
  user: authentication.user,
});

const mapDispatch = {
  addCurrentSearchParamsToHistory, updateSearchParam, updateSearchMeta, resetSearchPrams,
};

export default connect(
  mapState,
  mapDispatch,
)(ShareholderCard);
